$(document).on("submit", "#contact-form", function (e) {
  e.preventDefault();

  const isValid = validateContactForm($(this));

  if (!isValid) {
    const errorElement = $("#contact-form .error").first() ?? false;

    if (errorElement) {
      $("html, body").animate(
        { scrollTop: errorElement.offset().top - 250 },
        "slow",
      );
    }
  }

  if (isValid) {
    let $successMessage = $("#success-message");
    $.ajax({
      type: "POST",
      url: localized.admin_ajax,
      data: new FormData($(this)[0]),
      dataType: "json",
      contentType: false,
      processData: false,
      success: function (response) {
        console.log(response);
        if (
          response.data &&
          (response.data.form_sent || response.data.form_saved)
        ) {
          $successMessage.fadeIn(350);
          $("html, body").animate(
            { scrollTop: $successMessage.offset().top - 100 },
            "slow",
          );
        }
      },
      error: function (response) {
        if (
          response.data &&
          (response.data.form_sent || response.data.form_saved)
        ) {
          $successMessage.fadeIn(350);
          $("html, body").animate(
            { scrollTop: $successMessage.offset().top - 100 },
            "slow",
          );
        }
      },
    });
  } else {
    console.log("form was invalid");
  }
});

const validateContactForm = ($form) => {
  let valid = true;

  if (!validateInputs($form.find("input[required]"))) valid = false;

  return valid;
};

export const validateInputs = (
  $inputs,
  validation = ($input) => {
    $input.closest(".input-group").removeClass("error");

    if (isEmptyString($input.val())) {
      $input.closest(".input-group").addClass("error");
      return false;
    }
    return true;
  },
) => {
  if ($inputs.length <= 0) return false;

  // If filter returns 0 items, that means all inputs passed the validation
  return (
    !$inputs.filter(function () {
      return !validation($(this));
    }).length > 0
  );
};

export const isEmptyString = (string) => {
  if (typeof string !== "undefined" && string) {
    return !string.trim().length;
  }

  return true;
};
